
class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this._rootSelector = null;
		this.observer = null;
		this.observerOptions = {
			root: document,
			rootMargin: "0px",
			threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9]
		}
	}

	get video() {
		return this.querySelector("video");
	}

	get rootSelector() {
		return this._rootSelector;
	}

	set rootSelector(selector) {
		this._rootSelector = selector;
		this.observerOptions.root = document.querySelector(selector);
		if (this.observer) {
			this.observer.disconnect();
			this.createObserver();
		}
	}

	play() {
		this.video.play();
	}

	reset() {
		if (!this.video.paused) {
			this.video.pause();
			this.video.currentTime = 0;
		}
	}

	onIntersect(entries) {
		entries.forEach(entry => {
			entry.isIntersecting ? this.play() : this.reset()
		});
	}

	createObserver() {
		this.observer = new IntersectionObserver(this.onIntersect.bind(this), this.observerOptions);
		this.observer.observe(this.video);
	}

	connectedCallback() {
		this.createObserver();
	}
}

if (!customElements.get("deferred-media")) customElements.define("deferred-media", DeferredMedia);